module.exports = __webpack_public_path__ + "img/icon-org-default.1cca00c6.svg";